import React, { useEffect, useState } from "react";
import { Logo } from "../../components/Logo";
import { PageFooter } from "../../components/PageFooter";
import "./index.css";

export function Home() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // ローディング画面を表示してから消す
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="home-wrapper">
      {/* ローディング画面 */}
      {isLoading && (
        <div className="loading-screen">
          <div className="spinner"></div>
          <img
            src="/images/hello-kitty-face.png"
            alt="Loading..."
            className="loading-kitty"
          />
        </div>
      )}

      {/* 背景 */}
      <div className="home-background"></div>

      {/* メインコンテンツ */}
      <div className="home-content">
        {/* ロゴ */}
        <Logo />

        {/* ソーシャルリンク */}
        <div className="social-links">
          <a
            href="https://discord.gg/hellokittyskyland"
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-discord"></i>
            <span>Discord</span>
          </a>
          <a
            href="https://www.tiktok.com/@hellokittyskyland_3vs"
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-tiktok"></i>
            <span>TikTok</span>
          </a>
          <a
            href="https://x.com/HelloKitty_3vs"
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-x-twitter"></i>
            <span>X</span>
          </a>
          <a
            href="https://www.instagram.com/hellokittyskyland_thirdverse/"
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-instagram"></i>
            <span>Instagram</span>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100021562074111"
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-facebook"></i>
            <span>Facebook</span>
          </a>
    {/*
https://www.threads.com/@hellokittyskyland_thirdverse
    */}
        </div>

        <div className="home-content-bottom">
          <a
            href="https://www.meta.com/experiences/24351103704475532/"
            className="home-content-bottom-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Play Free Now</span>
          </a>
          <img src="/images/metalogo.png" alt="Meta" className="home-content-bottom-image" />

          {/*
          <a
            href="https://www.meta.com/experiences/24351103704475532/"
            className="home-content-bottom-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Wish List Now</span>
          </a>
          */}
        </div>
      </div>

      {/* フッター */}
      <PageFooter className="fixed" />
    </div>
  );
}

